import React, { useMemo, useState } from 'react';
import layout from '../data/bonogramLayout.json';
import PlotMap from '../components/PlotMap';

// Demo: the static Bonogram layout with made-up statuses. The real project page
// reads its layout and live Unit.status from the API (ProjectLayoutTab).
const AREA_BY_TYPE = {
  A: ['3K-00CH-00', 2206],
  D: ['2K-06CH-08', 2003],
  C: ['2K-02CH-06', 1521],
  E: ['1K-08CH-09', 1192],
  B: ['1K-08CH-00', 1153],
  H: ['2K-04CH-16', 1736],
  J: ['1K-10CH-16', 1193]
};

// Deterministic mock so the demo looks the same on every load.
const mockStatus = (id) => {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) % 997;
  const r = h % 10;
  if (r < 4) return 'vacant';
  if (r < 6) return 'booked';
  if (r < 7) return 'hold';
  if (r < 9) return 'sold';
  return 'reserved';
};

const PlotMapDemo = ({ embedded = false }) => {
  const [statusById, setStatusById] = useState(() =>
    Object.fromEntries(layout.plots.map((p) => [p.id, mockStatus(p.id)]))
  );

  const plots = useMemo(
    () =>
      layout.plots.map((p) => ({
        key: p.id,
        label: p.id,
        points: p.points,
        status: statusById[p.id],
        details: [
          ['Type', p.type],
          ['Plot area', `${AREA_BY_TYPE[p.type]?.[0]} sq.ft`],
          ['Bungalow', `${AREA_BY_TYPE[p.type]?.[1]} sq.ft`]
        ]
      })),
    [statusById]
  );

  return (
    <PlotMap
      layout={{ ...layout, imageUrl: '/layouts/bonogram-master-plan.webp' }}
      plots={plots}
      title="Bonogram — Master Plan (prototype)"
      subtitle="Mock statuses. Click a plot for details."
      embedded={embedded}
      onStatusChange={(key, status) => setStatusById((s) => ({ ...s, [key]: status }))}
    />
  );
};

export default PlotMapDemo;
